export const API_UNAUTHORIZED = "API_UNAUTHORIZED";
export const UNAUTHORIZED_STATUS_CODE = 401;
